module.exports = __webpack_public_path__ + "img/icon_down_arrow.bb71d27d.svg";